require("./app_articleHeaderAppComponent.less")
import { SiteSettingsHOC, SiteSettings } from "global/components/siteSettingsHOC"

interface ArticleAppHeaderShareProps {
    showComments: boolean
    isSpotim?: boolean
    isMagazineArtice?:boolean
    magazine2025?:boolean
}

@SiteSettingsHOC()
export class ArticleAppHeaderShareComponent extends React.Component<Partial<SiteSettings> & ArticleAppHeaderShareProps>{


    private getLinkText = () => {
        const { isSpotim, sitename } = this.props
        const commentNumber = "";
        let txt = " תגובות";
        let addTxt = "הוספת תגובה"
        if(sitename==="radionas"){
            txt = " تعليقات";
            addTxt = "اضف تعليق"

        }
        const commentExistTxt = <a className="toAllComments-pf" href="go_to_all_comments">{commentNumber}   {txt}<span className="icon-pf" /></a>;
        const addComment = <a className="toAllComments-pf" href="go_to_all_comments"><span className="icon-pf" />{addTxt}</a>;
        const spotimElement = <a href="spotComments" className="toAllComments-pf" ><span id="spotimCmtCounter" /><span className="icon-pf" /></a>
        if (isSpotim) {
            return spotimElement
        }
        else {
            if (commentNumber.length) {
                return commentExistTxt
            }
            return addComment;
        }
    }


    render() {
        const { platform, showComments, sitename, isMagazineArtice, magazine2025 } = this.props

        switch (platform) {
            case "mutam":
                return null
            default:
                return (
                    <div className="articleShareButtons-pf" id="share-icons-wrapper-android" >
                        <div>
                            <a href="whatsapp:">
                                <span className="icon-pf whBtn" />
                            </a>
                            <a href="facebook.com/sharer/">
                                <span className="icon-pf fcBtn" />
                            </a>
                            {(sitename === "radionas") && <> <a href="twitter.com/sharer/">
                                <span className="icon-pf twBtn" />
                            </a>
                                <a href="mail/sharer/">
                                    <span className="icon-pf mailBtn" />
                                </a></>}
                               {!isMagazineArtice &&   <a href="share_article">
                                <span className="icon-pf shareBtn" />
                            </a>}
                            {sitename !== "radionas"  &&  <a href="copy_article">
                                <span className="icon-pf copyBtn" />
                            </a>}
                        </div>

                        {showComments && this.getLinkText()}
                    </div>
                )
        }
    }
}
